export default {
    setMovimento ( state, payload) {
        state.movCaixaEntradaManual = payload;
    },

    updateMovimento(state, payload) {
        state.movCaixaEntradaManual = payload;
        
    }
}